import createRoute  from '@widesk-ui/tools/createRoute';
import ProductModel from '@models/shop/ProductModel';

export default createRoute.dashboard('/entertainments/:entertainmentId/products', 'shop', 'ProductDashboard', ProductModel.localize());
